import { Link } from 'react-router-dom'

import RichText from '../../../components/RichText/RichText'

export default function CallToActionBlock (props = {
    heading: null,
    richText: null,
    bgColor: null,
    color: null,
    cta: {
        href: null,
        text: null
    },
    img: {
        src: null,
        alt: null,
        width: null,
        height: null
    },
    textSecondary: null
}) {
    if (!props.heading
            && !props.richText
            && (!props.cta?.href
                || !props.cta?.text))
        return null

    return (
        <section className="call-to-action-block pad-section text-align-center">
            <div
                className={props.bgColor
                    && 'pad-section'}
                style={{
                    backgroundColor: props.bgColor,
                    color: props.color
                }}
            >
                <div className="container">
                    <div className="row flex-justify-content-center">
                        {props.img
                            && props.img.src
                            && (
                                <div className="call-to-action-block-gfx">
                                    <img
                                        src={props.img.src}
                                        alt={props.img.alt || ''}
                                        width={props.img.width}
                                        height={props.img.height}
                                    />
                                </div>)}
                        <div className="col-12 col-8-md col-6-lg-up">
                            {props.heading
                                && <h2>{props.heading}</h2>}
                            {props.heading
                                && props.richText
                                && <hr className="margin-4-t margin-4-b" />}
                            {props.richText
                                && <RichText className="body-2" html={props.richText} />}
                            {props.cta
                                && props.cta.href
                                && props.cta.text
                                && (
                                    <div
                                        className={(props.heading || props.richText)
                                            && 'margin-4-t'}
                                    >
                                        <Link
                                            to={props.cta.href}
                                            className="btn-lg btn-secondary pad-2-l pad-2-r"
                                        >
                                            {props.cta.text}
                                        </Link>
                                    </div>)}
                            {props.textSecondary
                                && (
                                    <RichText
                                        className="body-3 margin-4-t"
                                        html={props.textSecondary}
                                    />)}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
